import mainBridge from "@maru/main-app";
import {ProjectService} from "@maru/libcore/gen/project_pb_service";
import * as google_protobuf_empty_pb from "google-protobuf/google/protobuf/empty_pb";
import { ProjectDraftSettingsResponse, ProjectDraftSettings, UpdateProjectTypeRequest } from "@maru/libcore/gen/project_types_pb";

export type DraftSetting = ProjectDraftSettings.AsObject;

export const getProjectDraftSettings = async (settings: string[]): Promise<ProjectDraftSettingsResponse.AsObject> => {
  return await mainBridge.call(ProjectService.GetProjectDraftSettings.methodName, settings);
}

export const updateProjectDraftSettings = async (settings: { [key: string]: string }): Promise<google_protobuf_empty_pb.Empty> => {
  try {
    return await mainBridge.call(ProjectService.UpdateProjectDraftSettings.methodName, settings);
  } catch (e: unknown) {
    console.error(e);
    return null;
  }
}

export const createProjectDraftSettings = async (settings: { [key: string]: string }): Promise<google_protobuf_empty_pb.Empty> => {
  try {
    return await mainBridge.call(ProjectService.CreateProjectDraftSettings.methodName, settings);
  } catch (e: unknown) {
    console.error(e);
    return null;
  }
}

export const updateSourceTemplateProjectType = async (params: UpdateProjectTypeRequest.AsObject): Promise<google_protobuf_empty_pb.Empty> => {
  try {
    return await mainBridge.call(ProjectService.UpdateProjectType.methodName, params);
  } catch (e: unknown) {
    console.error(e);
    return null;
  }
}

export const updateProjectDataOnStore = async (params: { projectId: string }): Promise<any> => {
  try {
    return await mainBridge.call(ProjectService.GetProjectById.methodName, params);
  } catch (e: unknown) {
    console.error(e);
    return null;
  }
}

/**
 * Read the current user's role within a project from core's authoritative
 * `GetProjectById` response (the same project data the shell already loads),
 * rather than from the survey session response variables.
 *
 * Returns the numeric `project.UserRole` enum value, or `null` when it cannot
 * be resolved (e.g. not embedded / bridge unavailable).
 */
export const getProjectUserRole = async (projectId: string): Promise<number | null> => {
  try {
    const project = await mainBridge.call(ProjectService.GetProjectById.methodName, { projectId });
    const userRole = project?.userRole ?? project?.project?.userRole;
    return typeof userRole === 'number' ? userRole : null;
  } catch (e: unknown) {
    console.error(e);
    return null;
  }
}

